import React, { Component } from 'react';
import { Link, Navigate, useNavigate } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';
import CustomModal from "../Bar/CustomModal";
import Pagination from '../Bar/Pagination';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { eventWrapper } from '@testing-library/user-event/dist/utils';
import PopupImage from '../Bar/PopupImage';

export class BlindTestEdit extends React.Component {

    constructor(props) {
        super(props)
      
        this.state = {
          data: null,
          page: 1,
          blind_test_id: null,
          blind_tests: [],
          percentage: 0,
          disable: true,
          filename: "",
          full_image_url: "",
          correct_answer: null,
          name: null,
          total: 0,
          limit: 10,
          success: null,
          s: '',
          fields: {
            name: "",
            correct_answer: ""
          },
          errors: {},
        }
        this.inputRefs = {
          name: React.createRef(),
          correct_answer: React.createRef(),
        };
      }

      UNSAFE_componentWillMount() {
        // if(this.getParam("id")) {
        //   this.getOneBlindTest();
        //   this.getImage();
        // } else {
        //   setTimeout(() => {
        //     this.setState({})
        //   }, 300);
        // }
        this.getParam('id')
        this.getOneBlindTest();
        this.getImage();
        
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.blind_test_id = id;
        this.setState({})
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

    
      getOneBlindTest = async () => {
        try {
          let query = `id=${this.state.blind_test_id}`
          let results = await API.getOneBlindTest(query);
    
          let data = results.data;

          // this.setState({ 
          //   name : data.name, 
          //   correct_answer: data.correct_answer,
          //   image_url: data.image_url,
          //   full_image_url: data.full_image_url
          // });
          this.state.name = data.name;
          this.state.correct_answer = data.correct_answer;
          this.state.filename = data.image_url;
          this.state.full_image_url = data.full_image_url;
          this.state.fields.name = data.name;
          this.state.fields.correct_answer = data.correct_answer.toString();
          this.setState({})
    
        } catch (error) {
          console.log(error)
        }
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.state.filename = results.filename;
            this.state.full_image_url = results.full_url;
            this.setState({});
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      handelInput = (event) => {

        const { name, value } = event.target;
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: "", // Clear error for the field being updated
          },
        }));
      }
      // handelInput = (event) => {
      //   event.preventDefault();
      //   let value = event.target.value;
      //   let name = event.target.name;
        
      //   this.setState({ blind_tests: {
      //     ...this.state.blind_tests,
      //     [name]: value
      //   }})
      // }
      validateFields = () => {
        const { fields } = this.state;
        const errors = {};
        let firstEmptyField = null;
    
        // Check for empty fields
        Object.keys(fields).forEach((field) => {
          const value = fields[field];
          if (typeof value !== "string" || !value.trim()) {
            errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      
            // Record the first empty field for focus
            if (!firstEmptyField) {
              firstEmptyField = field;
            }
          }
        });
    
        this.setState({ errors });
    
        // Focus on the first empty field
        if (firstEmptyField) {
          this.inputRefs[firstEmptyField].current.focus();
        }
    
        // Return true if no errors
        return Object.keys(errors).length === 0;
      }
    
      handleSubmit = async (event) => {
        event.preventDefault();
        if (!this.validateFields()) return
        let data = {
          id: this.state.blind_test_id,
          name: this.state.name,
          correct_answer: this.state.correct_answer,
          image_url: this.state.filename
        }
        
        try {
          let results = await API.postOneBlindTest(
            data
          );
          if (results.result === 1){
            // this.setState({ success: results.result })
            this.goBack();
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      deleteQuiz = async (event) => {
        event.preventDefault();
        let data = {
          id : this.state.data.id
        }
        try {
          let results = await API.postDeleteBlindTest(data);
          
          if (results.result){
            toast.success("Your action is successful", {
              data: {
                title: "Success toast",
                text: "This is a success message",
              },
            })
            this.goBack();
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      goBack = () => {
        this.props.navigate(-1); // Navigate to the previous page
      };

  render() {
    const { fields, errors } = this.state;
    return (
        <div className="col-12">
          <ToastContainer />
          {this.state.success && (
              <Navigate to="/categoryindex?success=true" replace={true} />
          )}
            <form className="card" onSubmit={this.handleSubmit}>
                <h4 className="card-title"><strong>Blind Test</strong></h4>

                <div className="card-body row">

                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name</label>
                        {/* <input type="text" className="form-control" id="input-required" value={this.state.name} name='name' 
                          style={{
                            border: errors.name ? "2px solid red" : "", 
                          }}
                          ref={this.inputRefs.name}
                          onChange={(event) => {
                          this.state.name = event.target.value;
                          this.setState({})
                          this.handelInput(event)
                      }} />
                      {errors.name && <span style={{ color: "red" }}>{errors.name}</span>} */}
                      <input type="text" className="form-control" id="input-required" value={this.state.name} name='name' 
                        ref={this.inputRefs.name}
                        style={{
                          border: errors.name ? "1px solid red" : "", 
                        }}
                        onChange={(event) => {
                          this.state.name = event.target.value;
                          this.setState({})
                          this.handelInput(event)
                        }} />
                        {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
                    </div>
                    
                    
                    {/* <div className="form-group">  
                        <label for="inputState" className="col-form-label">Parent</label>
                        <select id="inputState" className="form-control">
                        <option>Short Film</option>
                        <option>Funny</option>
                        <option>Love story</option>
                        <option>Sad story</option>
                        </select>
                    </div> */}
                    
                    </div>
                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Correct answer</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.correct_answer} name='correct_answer' 
                          style={{
                            border: errors.correct_answer ? "1px solid red" : "", 
                          }}
                          ref={this.inputRefs.correct_answer}
                          onChange={(event) => {
                          this.state.correct_answer = event.target.value;
                          this.setState({})
                          this.handelInput(event)
                      }} />
                      {errors.correct_answer && <span style={{ color: "red" }}>{errors.correct_answer}</span>}
                    </div>
                    </div>


                    
                    <div className="col-md-6">
                      <div className="form-group">
                          <label>Thumbnail</label>
                          <div style={{
                            marginTop: '10px',
                            textAlign: 'center', 
                            // MaxHeight: '50px',
                            height: this.state.full_image_url ? '250px' : 0,
                            // objectFit: 'cover'
                            display: 'flex', // Flexbox for alignment
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            }}>
                          {this.state.full_image_url && <PopupImage
                            thumbnailUrl={this.state.full_image_url} 
                            imageUrl={this.state.full_image_url} 
                          />
                          }
                          </div>
                          <input type="file" data-provide="dropify" name='thumbnail_url' onChange={this.onChangeFile} />
                          {/* <div class="progress">
                            < div class="progress-bar" role="progressbar" style={{width: this.state.percentage + "%", height: '10px'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{this.state.percentage + "%"}</strong></div>
                          </div> */}
                      </div>
                    </div>
                </div>

                {/* <Pagination 
                onPaginationPress={this.onPaginationPress}
                totalPageLength = {this.state.total}
                limit = {this.state.limit}
                selectPage = {this.state.page}
              /> */}

                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/blindtestindex">Back</Link>
                    {/* <button className="btn btn-secondary" onClick={this.goBack}>Back</button> */}
                    <button className="btn btn-primary" type="submit">Submit</button>
                </footer>
            </form>
            {
              this.state.data &&
              <CustomModal 
                data={ this.state.data } 
                title="Do you really want to delete this blind test?"
                deleteQuiz = {this.deleteQuiz} 
              />
           }
        </div>
    )
  }
}

// Functional wrapper to provide navigate
const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <BlindTestEdit navigate={navigate} />;
};

export default MyComponentWithNavigate;